<script>
import axios, { AxiosResponse } from 'axios';
import Vue from 'vue';

export default class MulesoftFiService extends Vue {
  static getAllMulesoftCores() {
    const response = axios.get('/api/mulesoftcore/getAllCores').then((res) => {
      if (res.data) {
        const coreNamesList = res.data.map(data => data.coreName);
        return coreNamesList;
      }
      return [];
      // Returns empty array if the back-end call pulls data from an empty table
    });
    return response;
  }

  static getMulesoftCoreRelationships(version, coreName) {
    const mulesoftRelationships = axios.get(`/api/mulesoftcore/mulesoft/core/${version}/${coreName}`).then((data) => {
      const jsonRelationships = JSON.parse(data.data.config.relationships);
      const relationships = Object.values(jsonRelationships);
      const uniqueRelationships = new Set();
      for (let i = 0; i < relationships.length; i++) {
        const relationshipSplitString = relationships[i].split(',');
        Object.values(relationshipSplitString).forEach((value) => {
          if (value !== 'ignore' && value !== 'empty') {
            uniqueRelationships.add(value);
          }
        });
      }
      const fiFileNames = {};
      const uniqueArray = Array.from(uniqueRelationships);
      uniqueArray.forEach((relationship) => {
        fiFileNames[relationship] = '';
      });
      return fiFileNames;
    });
    return mulesoftRelationships;
  }

  static addFi(newFiData) {
    const payload = {};
    const keys = Object.keys(newFiData);
    const values = Object.values(newFiData);
    for (let i = 0; i < keys.length; i++) {
      payload[keys[i]] = values[i];
    }

    axios.put('/api/mulesoftfi/addFi/', payload);
  }

  static getFiTable() {
    const fieldNamesPayload = 'version, fiid, config';
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = axios.put('/api/mulesoftfi/getFiTable', fieldNamesPayload, { headers }).then(data => data.data);
    return response;
  }
}
</script>
